import React from "react";

import Posts from "./Posts";
import Stories from "./Stories";
import { useAuth } from "../lib/auth";


type FeedProps = {};

const Feed: React.FC<FeedProps> = () => {
  const { isAuthenticated, user } = useAuth();

  return (
    <div className="grid mt-2 grid-cols-1 mx-auto">
      <section className="col-span-2" aria-label="جریان پست‌ها">
        { (isAuthenticated && user) &&
           <Stories />
        }
        <Posts />
      </section>
    </div>
  );
};
export default Feed;
